export enum EWorkflowPathKey {
	DETAIL = 'DETAIL',
	OVERVIEW = 'OVERVIEW',
	STAMMDATEN = 'STAMMDATEN',
	RUN = 'RUN',
}
